import { render, staticRenderFns } from "./passkey_authentication.vue?vue&type=template&id=0a57b647"
import script from "./passkey_authentication.vue?vue&type=script&lang=js"
export * from "./passkey_authentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports